export enum RequisitesCascadeMode {
  TradersFirst = 'traders_first',
  ProvidersFirst = 'providers_first',
  TradersOnly = 'traders_only',
  ProvidersOnly = 'providers_only',
  Parallel = 'parallel',
}
